<template>
  <LayoutCoursesDetail></LayoutCoursesDetail>
</template>

<script>
import LayoutCoursesDetail from "../components/LayoutCoursesDetail.vue";

export default {
  components: {
    LayoutCoursesDetail,
  },
  created() {
    window.scrollTo(0, 0);
  },
  mounted() {
    this.$store.commit("footer", false);
    this.$store.commit("showSearchCart", false);
  },
  destroyed() {
    this.$store.commit("footer", true);
    this.$store.commit("showSearchCart", true);
  },
  methods: {},
};
</script>

<style></style>
